// Meme data structure
export const memes = [
  // {
  //   id: 1,
  //   image: '/assets/meme1.jpg',
  //   alt: 'Solenskee Meme 1'
  // },
  // {
  //   id: 2,
  //   image: '/assets/meme2.jpg',
  //   alt: 'Solenskee Meme 2'
  // }
];

// Function to load memes
export function loadMemes() {
  return memes;
}

// Function to add a new meme
export function addMeme(meme) {
  memes.push({
    id: memes.length + 1,
    ...meme
  });
}
